import graphql from './graphql';

const query = /* GraphQL */ `
  query User_isSubscribed($courseId: ID!, $userId: ID!) {
    User_isSubscribed(courseId: $courseId, userId: $userId)
  }
`;

const IsUserSubscribed = async ({ courseId, userId }) =>
  graphql(query, { courseId, userId })
    // eslint-disable-next-line camelcase
    .then(({ User_isSubscribed }) => User_isSubscribed)
    .catch(err => err);

export default IsUserSubscribed;
